import { render } from "./PermissionTreeTable.vue?vue&type=template&id=672e7560"
import script from "./PermissionTreeTable.vue?vue&type=script&lang=js"
export * from "./PermissionTreeTable.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/pengadaan/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__